module.exports = __webpack_public_path__ + "img/720-icon.dd078209.png";